module.exports = __webpack_public_path__ + "static/media/400010_01.0071e4fe.png";